module.exports = __webpack_public_path__ + "static/media/blackbody.e14f80bf.jpg";